import APIUtils from '@spothero/utils/api';

const CreditAPI = {
    checkPromoCode(requestData) {
        return APIUtils.post('promocodes/check/', requestData);
    },

    update(requestData) {
        const {
            userId,
            amountChanged,
            reason
        } = requestData;

        return APIUtils.patch(`users/${userId}/credit/`, {
            credit_delta: parseFloat(amountChanged), // eslint-disable-line camelcase
            reason,
            notify_user: false // eslint-disable-line camelcase
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    getUpdateReasons() {
        return APIUtils.get('credit-reason/');
    }
};

export default CreditAPI;
